import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { transformPropOrder } from './keys-transform.mjs';
var positionalKeys = new Set(["width", "height", "top", "left", "right", "bottom"].concat(_toConsumableArray(transformPropOrder)));
export { positionalKeys };